module.exports = __webpack_public_path__ + "static/img/products discription_tape PVC2.9ee4464b.jpg";